import { useQuery, useQueryClient } from "@tanstack/react-query";
import useAPI from "../../../../../api/hooks/useAPI";
import { platformUsersKeys } from "../../../../../api/queryKeys";
import FavoritesButton from "../../../../../components/FavoriteButton";
import FavoriteTag from "../../../../../components/FavoriteTag";

const EntityFavoritesButton = ({ entityId, icon = false }) => {
  const { toggleFavoriteEntity, getFavoriteEntities, trackEvent } = useAPI();
  const queryClient = useQueryClient();
  const { data: fetchedFavoriteEntities, isLoading: isLoadingFavorites } =
    useQuery({
      queryKey: platformUsersKeys.favoriteEntities(),
      queryFn: getFavoriteEntities,
      select: (data) => data.data,
    });
  const isFavorite = fetchedFavoriteEntities?.includes(entityId);
  const isLoading = isLoadingFavorites;

  const handleToggleFavorite = async () => {
    trackEvent(
      isFavorite
        ? `User removed favorite entity  ${entityId}`
        : `User added favorite entity ${entityId}`
    );

    await toggleFavoriteEntity(entityId, !isFavorite).then(() => {
      queryClient.invalidateQueries({
        queryKey: platformUsersKeys.favoriteEntities(),
      });
    });
  };

  return icon ? (
    isFavorite ? (
      <FavoriteTag />
    ) : null
  ) : (
    <FavoritesButton
      handleToggleFavorite={handleToggleFavorite}
      isFavorite={isFavorite}
      isLoading={isLoading}
      sx={{
        border: "none",
      }}
    />
  );
};

export default EntityFavoritesButton;
